import { httpResource } from '@angular/common/http';
import { effect, Injectable, Signal, signal } from '@angular/core';
import { RoleInterface } from './todo-interface';
import { environment } from '../../../environments/environment';
import { IUserRole, Role, UserRole, EnvVars } from '../../models/models.lib';
import { z } from 'zod';
import { LoggerService } from '../../shared/logger.service';

const { apiUrl } = environment;

@Injectable({
  providedIn: 'root'
})
export class TodoService {
  readonly roleResource = httpResource<Array<RoleInterface>>(() => `${apiUrl}/findroles`);
  readonly testResource = httpResource<EnvVars>(() => `${apiUrl}/api/envvars`);

  testFlag = signal<boolean>(false);

  constructor(
    private logger: LoggerService
  ) {
    effect(() => {
      this.logger.debug(`constructor:effect fired...`, this.testResource.value());
      this.testFlag.set(this.testResource.value()?.testFlag ?? false);
      this.logger.debug(`constructor:testFlag: `, this.testFlag());
    })
  }

  IUserRoleSchema = z.object({
    role_id: z.number()
  });
  UserRoleSchema = z.array(this.IUserRoleSchema);

  createRolesResource() {
    return httpResource<Role[]>(() => (
      {
        url: `${apiUrl}/roles`,
        method: 'GET',
        withCredentials: true
      }
    ),
      {
        parse: (data) => {
          this.logger.debug(`parse:data: `, data);
          if (!data) {
            throw new Error('Invalid data received');
          }
          return Array.isArray(data) ? data.map(x => Role.create(x)) : [];
        }
      });
  }

  createRoleResource($userId: Signal<string>) {
    return httpResource<IUserRole[]>(() => (
      $userId() ? encodeURI(`${apiUrl}/findanyuserroles/${$userId()}`) : undefined
    ));
  }
  createRoleResource2($userId: Signal<string>) {
    return httpResource<IUserRole[]>(() => (
      {
        url: encodeURI(`${apiUrl}/findanyuserroles/${$userId()}`),
        method: 'GET',
        withCredentials: true
      }
    ), {
      // parse: (data) => this.UserRoleSchema.parse(data)
      parse: (data) => {
        this.logger.debug(`parse:data: `, data);
        if (!data) {
          throw new Error('Invalid data received');
        }
        return Array.isArray(data) ? data.map(x => UserRole.create(x)) : [];
        // return this.UserRoleSchema.parse(data)
      }
    });
  }

}
